import { gql } from '@apollo/client'

export const SABRE_SHIPPING_FRAGMENT = gql`
  fragment Shipping on Shipping {
    id
    consumablesPerCase
    productsPerCase
  }
`
